import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogFooter, DialogType } from "office-ui-fabric-react/lib-commonjs/Dialog";
import { PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib-commonjs/Button";

import "./AlertDialog.scss";

export const AlertDialogButtonType = {
    Default: 0,
    Danger: 1,
    Success: 2,
};

class AlertDialog extends Component {
    show = async () => {
        const { onShow } = this.props;
        if (typeof onShow === "function") { await onShow(); }
    };

    onClickOk = async () => {
        
        const { onClickOk } = this.props;
        if (typeof onClickOk === "function") { await onClickOk(); }
    };

    onClickCancel = async () => {
      
        const { onClickCancel } = this.props;
        if (typeof onClickCancel === "function") { await onClickCancel(); }
    };

    render() {
        const {
            title,
            message,
            okButtonLabel,
            okButtonType,
            okButtonIconName,
            cancelButtonLabel,
            cancelButtonType,
            open,
            blocking,
        } = this.props;

        return (
            <Fragment>
                <Dialog
                    role="alert-dialog"
                    minWidth="30rem"
                    hidden={!open}
                    
                    onDismiss={this.onClickCancel}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title,
                        subText: message,
                        showCloseButton: false,
                        className: "alert-dialog",
                        styles: { subText: { fontSize: "0.9375rem" }, title: { fontSize: "1.5rem" } }
                    }}
                    modalProps={{ className: "alert-dialog-modal",isBlocking : false }}
                >
                    <DialogFooter>
                        {okButtonLabel && <PrimaryButton iconProps={{ iconName: okButtonIconName }} className={`dialog-btn-primary${okButtonType != null ? ` btn-${Object.keys(AlertDialogButtonType).find((v, i) => i === okButtonType).toLowerCase()}` : ""}`} onClick={this.onClickOk} text={okButtonLabel} />}
                        <DefaultButton className={`dialog-btn-secondary${cancelButtonType != null ? ` btn-${Object.keys(AlertDialogButtonType).find((v, i) => i === cancelButtonType).toLowerCase()}` : ""}`} primary={!okButtonType} onClick={this.onClickCancel} text={cancelButtonLabel} />
                    </DialogFooter>
                </Dialog>
            </Fragment>
        );
    }
}

AlertDialog.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string.isRequired,
    onShow: PropTypes.func,
    okButtonLabel: PropTypes.string,
    okButtonType: PropTypes.oneOf([AlertDialogButtonType.Default, AlertDialogButtonType.Danger, AlertDialogButtonType.Success]),
    okButtonIconName: PropTypes.string,
    onClickOk: PropTypes.func,
    cancelButtonLabel: PropTypes.string,
    cancelButtonType: PropTypes.oneOf([AlertDialogButtonType.Default, AlertDialogButtonType.Danger, AlertDialogButtonType.Success]),
    onClickCancel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    blocking : PropTypes.bool.isRequired,
};

AlertDialog.defaultProps = {
    cancelButtonLabel: "Cancel",
    cancelButtonType: AlertDialogButtonType.Default,
    title: "Are you sure?",
    blocking : false,
    okButtonType: AlertDialogButtonType.Default,
    open : false,
    message : ""
};

export default AlertDialog;